<template>
    <div class="form-group">
        <label :for="`tags-${_uid}`" v-text="label"></label>
        <input :name="`tags-${_uid}`" :id="`tags-${_uid}`" class="tags-field" :placeholder="placeholder">
    </div>
</template>
<script>

    export default {

        props: {
            value: {
                required: true,
            },
            options: {
                required: false,
            },
            label: {
                type: String,
                required: false,
                default: 'Tags',
            },
            placeholder: {
                type: String,
                required: false,
                default: 'Type your tags over here...',
            },
            maxTags: {
                type: Number,
                required: false,
                default: 10,
            }
        },

        data() {
            return {
                tagify: null,
            }
        },

        mounted() {
            this.initTagify();
            this.listenTags();
        },

        methods: {

            initTagify() {
                var selector = document.getElementById(`tags-${this._uid}`);

                this.tagify = new Tagify(selector, {
                    delimiters: ",",
                    tagTemplate: function (v, manufacture) {
                        return `<tag title="${v}">
                                    <div class="tag-item">
                                        <span class="tags_tag_text">${v}</span><x class="remove" title=""></x>
                                    </div>
                                </tag>`;
                    },
                    enforceWhitelist: false,
                    blacklist: ["fuck", "shit", "pussy"],
                    maxTags: this.maxTags,
                    whitelist: this.whiteList,
                    dropdown: {
                        enabled: 1,
                        classname: 'tagify__dropdown',
                        itemTemplate: function (tag) {
                            return `<div class='tagify__dropdown__item'><span>${tag.name}</span></div>`
                        }
                    },
                    mapValueToProp: "id",
                });

                if (this.value) {
                    this.tagify.addTags(this.parseItems(this.value));
                }
            },

            listenTags() {
                this.tagify.on('remove', event => {
                    if (this.isStringTag) {
                        this.$emit('input', "");
                        return;
                    }
                    this.$emit('input', this.tagify.value)
                });

                this.tagify.on('add', event => {
                    if (this.isStringTag) {
                        this.$emit('input', this.tagify.value[0].value);
                        return;
                    } else {
                        this.$emit('input', this.tagify.value)
                    }
                });
            },

            parseItems(items) {
                if (typeof items == 'string') {
                    return [{value: items}];
                }
                return _.map(items, item => {
                    if (item) {
                        if (item.value) return item;
                        return {
                            value: item.toString(),
                        }
                    }
                })
            }
        },

        computed: {

            isStringTag() {
                return this.maxTags == 1;
            },

            whiteList() {
                var options = this.options ? this.options : {};
                return this.parseItems(options);
            }
        }
    }
</script>
